import React from 'react';
import './RemoteSensing.scss';
import { useIntl } from 'react-intl';
import RemoteSensingPlaceholder from '../../../../../../assets/image/remote-sensing-placeholder.svg';

const RemoteSensing = () => {
  const translate = useIntl();

  return (
    <div className="remoteSensing">
      <img src={RemoteSensingPlaceholder} alt="RemoteSensing" />
      <h2 className="comingSoon">{translate.formatMessage({ id: 'coming-soon' })}</h2>
    </div>
  );
};

export default RemoteSensing;
